export default {"src":"/_next/static/media/stack.dff18ef9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};